module.exports = __webpack_public_path__ + "static/media/ClubBooth.0ccb9d0b.png";